<template>
    <div class="d-flex justify-content-between">
        <div class="d-flex">
            <nav id="countShow" class="bs-pagination position-relative d-sm-flex" v-if="state">
                <div class="page-item active">
                    <button class="page-link d-sm-none my-2">
                        {{ state.tableRows }}
                    </button>
                </div>
                <ul class="pagination my-2 bg-light d-none d-sm-flex" v-if="state && state.tableRows">
                    <li class="page-item" v-for="c in counts" :key="'c' + c" :class="{'active': c === state.tableRows}">
                        <button class="page-link" @click="$emit('pushPage', 1, c)">{{ c }}</button>
                    </li>
                </ul>
            </nav>
            <nav class="bs-pagination position-relative d-sm-flex">
                <ul class="pagination my-2 px-1 border-left" v-if="filters">
                    <li v-if="filters.after" class="page-item dropup" :class="state.filter ? 'active' : ''">
                        <button class="page-link dropdown-toggle">
                            <fa-icon :icon="['fal', 'calendar-check']"></fa-icon>
                        </button>
                        <div class="dropdown-menu">
                            <button
                                    v-for="filter in filterTypes.after.filters"
                                    :key="'fa-' + filter"
                                    @click="pushFilter(filter)"
                                    class="dropdown-item"
                            >
                                {{ $t('labels.filters.' + filter) }}
                            </button>
                            <div class="dropdown-divider"></div>
                            <button class="dropdown-item" @click="pushFilter('')">{{ $t('labels.clear') }}</button>
                        </div>
                    </li>
                    <li v-if="filters.client" class="page-item dropup" :class="state.filters.client ? 'active' : ''">
                        <button class="page-link dropdown-toggle">
                            <fa-icon :icon="['fal', 'address-book']"></fa-icon>
                        </button>
                        <div class="dropdown-menu">
                            <button
                                    v-for="filter in filterTypes.client.filters"
                                    :key="'fc-' + filter.id"
                                    @click="pushFilter({ client: filter.id })"
                                    class="dropdown-item"
                            >
                                {{ filter.name }}
                            </button>
                            <div class="dropdown-divider"></div>
                            <button class="dropdown-item" @click="pushFilter({ client: null })">{{ $t('labels.clear') }}</button>
                        </div>
                    </li>
                    <li v-if="filters.state" class="page-item dropup" :class="state.filters.state ? 'active' : ''">
                        <button class="page-link dropdown-toggle">
                            <fa-icon :icon="['fal', 'tags']"></fa-icon>
                        </button>
                        <div class="dropdown-menu">
                          <button class="dropdown-item" @click="pushFilter({ state: null })">{{ $t('labels.clear') }}</button>
                          <div class="dropdown-divider"></div>
                          <button
                                    v-for="filter in filterTypes.state.filters"
                                    :key="'s-' + filter"
                                    @click="pushFilter({ state: filter })"
                                    class="dropdown-item"
                            >
                              {{ $t('labels.' + filter) }}
                            </button>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
        <nav class="bs-pagination">
            <ul class="pagination my-2" v-if="lastPage > 1">
                <li class="page-item" v-if="currentPage > 1">
                    <button class="page-link" aria-label="Previous" @click="$emit('pushPage', 1)">
                        <fa-icon :icon="['fal', 'chevron-left']"></fa-icon>
                    </button>
                </li>
                <li class="page-item" v-for="page in pages" :key="'p' + page" :class="{'active': page === currentPage}">
                    <button class="page-link" @click="$emit('pushPage', page)">{{ page }}</button>
                </li>
                <li class="page-item" v-if="currentPage < lastPage">
                    <button class="page-link" aria-label="Next" @click="$emit('pushPage', lastPage)">
                        <span aria-hidden="true"><fa-icon :icon="['fal', 'chevron-right']"></fa-icon></span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    data: Object,
    state: Object,
    filters: Object,
    counts: {
      type: Array,
      default: () => { return [10, 20, 50, 100] }
    }
  },
  data () {
    return {
      offset: 1,
      filterTypes: {
        after: {
          show: false,
          filters: [
            'from_today',
            'from_week',
            'from_month',
            'from_quarter',
            'from_financial_year',
            'from_year'
          ]
        },
        client: {
          filters: this._.filter(this.$store.state.clientsStore, (c) => { return c.active })
        },
        state: {
          filters: [
            'pending',
            'completed'
          ]
        }
      }
    }
  },
  computed: {
    pages () {
      if (!this.data.meta || !this.data.meta.to) {
        return []
      }
      let from = this.data.meta.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      let to = from + (this.offset * 2)
      if (to >= this.data.meta.last_page) {
        to = this.data.meta.last_page
      }
      const pagesArray = []
      for (let page = from; page <= to; page++) {
        pagesArray.push(page)
      }
      return pagesArray
    },
    currentPage () {
      return this.data.meta ? this.data.meta.current_page : 0
    },
    lastPage () {
      return this.data.meta ? this.data.meta.last_page : 0
    }
  },
  methods: {
    pushFilter (filter) {
      document.activeElement.blur()
      this.filterTypes.after.show = false
      this.$emit('pushPage', 1, null, filter)
    }
  }
}
</script>

<style lang="scss">
    .bs-pagination {

        .page-link {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%!important;
            margin: 0 3px;
            padding: 0;
            width: 36px;
            height: 36px;
            font-size: 0.875rem;
        }

        .page-item.active > .page-link {
            box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
        }

        li.page-item:focus-within {

            > .dropdown-menu {
                display: block;
                overflow-x: scroll;
                max-height: 80vh;
            }
        }
    }

    @media(max-width: 575px) {
        #countShow {

            ul {
                position: absolute;
                bottom: 43px;
                padding: 0.5rem 0;
                border-right: 1px solid var(--border);

                li.page-item {
                    margin-bottom: 0.25rem;

                    &:first-child {

                        .page-link {
                            margin-left: auto;
                        }
                    }
                }
            }

            &:focus-within {

                ul {
                    display: block !important;
                }
            }
        }
    }
</style>
